import { FileTextOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import {
  Button,
  Col,
  Divider,
  FloatButton,
  Form,
  Modal,
  Row,
  Select,
  Tabs,
  message,
  Image,
} from "antd";
import { FC, useEffect, useState } from "react";
import MainCreateOrderProduct from "components/OrderManage/CreateOrders/ProductSection/MainCreateOrderProduct";
import { AddressData } from "../AddressComponents/interface/address.interface";
import AgentAddressCardList from "../AddressComponents/AgentAddressCardList";
import {
  FactoryCreateOrderInput,
  FactoryCreateOrderItems,
  GetAgentByIdResponse,
  OrderAddressData,
  OrderProductsTemporaryItem,
  PaymentOrderItems,
  TaxAddressData,
  TaxInvoiceOrderItems,
} from "services/interface";
import {
  useCreateOrderAdmin,
  useGetLoadNewOrders,
  useLoadTaxInvoiceList,
  useMutatePriceTransportation,
} from "hooks/useOrders";
import { useAppDispatch, useAppSelector } from "store";
import { useGetBankActiveList, useGetBankAllList } from "hooks/useFactory";
import MainCreateOrderPayment from "components/OrderManage/CreateOrders/PaymentSection/MainCreateOrderPayment";
import MainOrderDatasource from "components/OrderManage/CreateOrders/DatasourceSection/MainOrderDatasource";
import { formatYearMonthDateWithTime } from "utils/dateFormat";
import MainCreatePriceTransportation from "components/OrderManage/CreateOrders/PriceTransportationSection/MainCreatePriceTransportation";
import MainCreateTotalPricePayment from "components/OrderManage/CreateOrders/TotalPricePaymentSection/MainCreateTotalPricePayment";
import { backendUrl } from "config";
import OrderTabsCard from "components/OrderManage/OrderTabsCard";
import OrderPrepareShip from "components/OrderManage/OrderPrepareShip";
import OrderShipped from "components/OrderManage/OrderShipped";
import OrderCompleted from "components/OrderManage/OrderCompleted";
import OrderCancel from "components/OrderManage/OrderCancel";
import { setAgentId } from "store/slices/orderSlice";
import MainCreateOrderDuedate from "components/OrderManage/CreateOrders/DuedateSection/MainCreateOrderDuedate";
import dayjs from "dayjs";
import noImage from "assets/images/no-image.png";
import OrderCredit from "components/OrderManage/OrderCredit";
import MainCreateOrderTax from "components/OrderManage/CreateOrders/TaxSection/MainCreateOrderTax";

const { Option } = Select;
interface MainCreateAgentOrderProps {
  id: string;
  dataAddress: AddressData[];
  searchOption?: boolean;
  canUpdate?: boolean;
  setOrderData?: any;
  orderData?: any;
  canSort?: boolean;
  tabsKey?: string;
  refType: string;
  userData: GetAgentByIdResponse | undefined;
}

const MainCreateAgentOrder: FC<MainCreateAgentOrderProps> = ({
  id,
  searchOption,
  dataAddress,
  canUpdate,
  setOrderData,
  canSort,
  tabsKey,
  refType,
  userData,
}) => {
  const refIdKey = refType === "agent" ? "agent_id" : "retail_id";

  const dispatch = useAppDispatch();

  const pagging = useAppSelector((state) => state.order);
  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const [searchInput, setSearchInput] = useState<string>("");
  const [dateInput, setDateInput] = useState<string>("");
  const [disCount, setDisCount] = useState<number>(0);

  const [editingKey, setEditingKey] = useState("");
  const [currentSelected, setCurrentSelected] = useState<string>("");

  const [openForm, setOpenForm] = useState(false);

  useEffect(() => {
    dispatch(setAgentId(id));
  }, [id]);

  const {
    data: dataNewOrders,
    isLoading: newOrdersIsLoading,
    refetch: refectNewOrders,
  } = useGetLoadNewOrders({
    status: "new_order",
    [refIdKey]: id,
    search: searchInput,
    offset: pagging.dataNewOrders.offset,
    limit: pagging.dataNewOrders.limit,
  });

  const {
    data: dataPrepareShip,
    isLoading: prepareShipIsLoading,
    refetch: refectPrepareShip,
  } = useGetLoadNewOrders({
    status: "factory_approve",
    [refIdKey]: id,
    search: searchInput,
    offset: pagging.dataPrepareShip.offset,
    limit: pagging.dataPrepareShip.limit,
  });

  const {
    data: dataShipped,
    isLoading: shippedLoading,
    refetch: refectShipped,
  } = useGetLoadNewOrders({
    status: "wait_agent_confirm",
    [refIdKey]: id,
    search: searchInput,
    offset: pagging.dataShipped.offset,
    limit: pagging.dataShipped.limit,
  });

  const {
    data: dataCredit,
    isLoading: creditLoading,
    refetch: refectCredit,
  } = useGetLoadNewOrders({
    status: "credit_payment",
    [refIdKey]: id,
    search: searchInput,
    order_date: dateInput,
    offset: pagging.dataCredit.offset,
    limit: pagging.dataCredit.limit,
  });

  const {
    data: dataComplete,
    isLoading: completeLoading,
    refetch: refectchComplete,
  } = useGetLoadNewOrders({
    status: "complete",
    [refIdKey]: id,
    search: searchInput,
    offset: pagging.dataComplete.offset,
    limit: pagging.dataComplete.limit,
  });

  const {
    data: dataCancel,
    isLoading: cancelLoading,
    refetch: refectchCancel,
  } = useGetLoadNewOrders({
    status: "cancel",
    [refIdKey]: id,
    search: searchInput,
    offset: pagging.dataCancel.offset,
    limit: pagging.dataCancel.limit,
  });

  const items = [
    {
      label: `รับคำสั่งซื้อ (${dataNewOrders?.data?.total_record ?? 0})`,
      key: "0",
      children: (
        <>
          <OrderTabsCard
            data={dataNewOrders?.data}
            isLoading={newOrdersIsLoading}
            refetch={refectNewOrders}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
            refetchPrepare={refectPrepareShip}
            refetchCancel={refectchCancel}
            IsHiddenPersonInfo={true}
            setOpenForm={setOpenForm}
          />
        </>
      ),
    },
    {
      label: `เตรียมจัดส่ง (${dataPrepareShip?.data?.total_record ?? 0})`,
      key: "1",
      children: (
        <>
          <OrderPrepareShip
            data={dataPrepareShip?.data}
            isLoading={prepareShipIsLoading}
            refetch={refectPrepareShip}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
            refectShipped={refectShipped}
            refetchCancel={refectchCancel}
            IsHiddenPersonInfo={true}
            setOpenForm={setOpenForm}
          />
        </>
      ),
    },
    {
      label: `ระหว่างจัดส่ง (${dataShipped?.data?.total_record ?? 0})`,
      key: "2",
      children: (
        <>
          <OrderShipped
            data={dataShipped?.data}
            isLoading={shippedLoading}
            refetch={refectShipped}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
            refetchTo={refectchComplete}
            IsHiddenPersonInfo={true}
            setOpenForm={setOpenForm}
          />
        </>
      ),
    },
    {
      label: `เครดิตรอชำระ (${dataCredit?.data.total_record ?? 0})`,
      key: "3",
      children: (
        <>
          <OrderCredit
            data={dataCredit?.data}
            isLoading={creditLoading}
            refetch={refectCredit}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
            refetchTo={refectCredit}
            setOpenForm={setOpenForm}
          />
        </>
      ),
    },
    {
      label: `เสร็จสิ้น (${dataComplete?.data?.total_record ?? 0})`,
      key: "4",
      children: (
        <>
          <OrderCompleted
            data={dataComplete?.data}
            isLoading={completeLoading}
            refetch={refectchComplete}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
            IsHiddenPersonInfo={true}
            setOpenForm={setOpenForm}
          />
        </>
      ),
    },
    {
      label: `ยกเลิก (${dataCancel?.data?.total_record ?? 0})`,
      key: "5",
      children: (
        <>
          <OrderCancel
            data={dataCancel?.data}
            isLoading={cancelLoading}
            refetch={refectchCancel}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
            IsHiddenPersonInfo={true}
            setOpenForm={setOpenForm}
          />
        </>
      ),
    },
  ];

  const { mutate: createOrderAdmin } = useCreateOrderAdmin();
  const factory_id = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );
  const [paymentDate, setPaymentDate] = useState<Date | null>(null);
  const [dueDate, setDueDate] = useState<Date | null>(null);
  const [transport, setTransport] = useState<string>("");
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [servicePrice, setServicePrice] = useState<number>(0);
  const [isSwitch, setIsSwitch] = useState<boolean>(false);
  const { data: dataBank } = useGetBankActiveList(factory_id || "");

  const { mutate: calServicePrice } = useMutatePriceTransportation();

  const [dataAddressTax, setDataAddressTax] = useState<TaxAddressData[]>([]);
  const [addressIdSelected, setAddressIdSelected] = useState<string>("");
  const [requestTax, setRequestTax] = useState<boolean>(false);

  const {
    data: dataTax,
    isPending: taxPending,
    refetch: refetchTax,
  } = useLoadTaxInvoiceList({
    factory_id: factoryId ?? "",
    customer_id: id ?? "",
  });

  useEffect(() => {
    if (id && dataTax?.data) {
      const newTaxAddresses: TaxAddressData[] = dataTax.data.map(
        (tax: TaxAddressData) => {
          return {
            id: tax.id,
            name: tax.name,
            address_text: tax.address_text,
            telephone: tax.telephone,
            fax: tax.fax,
            email: tax.email,
            tax_no: tax.tax_no,
            factory_id: factoryId ?? "",
            ref_id: id,
            ref_type: "agent",
            is_active: tax.is_active,
          };
        }
      );

      setDataAddressTax(newTaxAddresses);

      const activeAddress = newTaxAddresses.find((tax) => tax.is_active);
      if (activeAddress) {
        setAddressIdSelected(activeAddress.id);
      } else {
        setAddressIdSelected("");
      }
    }
  }, [id, dataTax]);

  // const { data: serviceData } = useGetPriceTransportation(
  //   {
  //     transport_type: transport,
  //     total_price: totalPrice,
  //     agent_id: id,
  //   }
  // );

  const childrenBank: React.ReactNode[] = [];
  dataBank?.data?.map((item) => {
    return childrenBank.push(
      <Option key={item.id} value={item.id}>
        <span style={{ fontSize: "12px" }}>
          <ImageWrapper>
            <Image
              src={item.image ?? noImage}
              alt={item.bank_name}
              preview={false}
            />{" "}
            {item.bank_name} {item.account_no} {item.account_name}
          </ImageWrapper>
        </span>
      </Option>
    );
  });

  const [dataTemporary, setDataTemporary] = useState<
    OrderProductsTemporaryItem[]
  >([]);
  const createOrderAddress: AddressData[] = dataAddress;
  const [radioSelect, setRadioSelect] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [formAdd] = Form.useForm();
  const [formCancel] = Form.useForm();
  const [formSubmit] = Form.useForm();

  // useEffect(() => {
  //   setServicePrice(serviceData?.data.service_price ?? 0)
  // }, [serviceData]);

  useEffect(() => {
    const addressShip = dataAddress.find(
      (address) => address.address_id === radioSelect
    );
    setTransport(addressShip?.transport_type ?? "");
  }, [radioSelect]);

  useEffect(() => {
    const addressShip = dataAddress.find(
      (address) => address.address_id === radioSelect
    );
    calServicePrice(
      {
        transport_type: transport,
        total_price: totalPrice,
        [refIdKey]: id,
        province_id: addressShip?.province_id ?? 0,
        district_id: addressShip?.district_id ?? 0,
        factory_id: factoryId ?? "",
      },
      {
        onSuccess: async (data) => {
          setServicePrice(data.data.service_price);
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }, [id, totalPrice, transport, radioSelect]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpenForm(false);
    formSubmit.resetFields();
    setDataTemporary([]);
    setRadioSelect("");
    setDueDate(null);
    setIsSwitch(false);
    setDisCount(0);
  };

  const onFinishAdd = (values: any) => {
    if (!values.datasource) {
      message.error("กรุณาเลือกช่องทางการสั่งซื้อ");
      return;
    }

    const payment: PaymentOrderItems = {
      amount: values.payment_amount,
      bank_id: values.bank_id,
      image_slip: values?.payment_images
        ? `${backendUrl}images/${values.payment_images[0].id}`
        : "",
    };

    if (paymentDate) {
      payment.payment_date = formatYearMonthDateWithTime(paymentDate);
    }

    const addressShip = createOrderAddress.find(
      (address) => address.address_id === radioSelect
    );
    let shipAddressData: OrderAddressData | undefined;
    if (addressShip) {
      shipAddressData = {
        address_id: addressShip.address_id || "",
        address_line_1: addressShip.line_1 || "",
        address_line_2: addressShip.line_2 || "",
        ref_id: id,
        ref_type: refType,
        address_type: addressShip.address_type || "",
        address_name: addressShip.address_name || "",
        address_telephone: addressShip.address_telephone || "",
        transport_type: addressShip.transport_type || "",
        location_type: addressShip.location_type || "",
        province_id: addressShip.province_id || 0,
        is_default: addressShip.is_default || false,
        province_name: addressShip.province_name || "",
        district_id: addressShip.district_id || 0,
        district_name: addressShip.district_name || "",
        sub_district_id: addressShip.sub_district_id || 0,
        sub_district_name: addressShip.sub_district_name || "",
        zip_code: addressShip.post_code || "0",
        remark: addressShip.address_remark,
        address_text: addressShip.address_text || "",
      };
    }
    const productItems: FactoryCreateOrderItems[] = dataTemporary.map(
      (item) => ({
        product_id: item.product_id,
        price_id: item.price_id || "",
        item_qty: item.qty,
        factory_price: item.factory_price,
        wholesale_price: item.wholesale_price,
        retail_price: item.retail_price,
        vip_price: item.vip_price,
        sku_qty: item.product_quantity,
      })
    );

    const addressTax = dataAddressTax.find(
      (address) => address.id === addressIdSelected
    );
    let taxInvoiceItems: TaxInvoiceOrderItems | null = null;
    if (addressTax) {
      taxInvoiceItems = {
        tax_invoice_id: addressTax?.id,
        factory_id: factoryId || "",
        ref_id: id || "",
        ref_type: refType || "",
        tax_no: addressTax?.tax_no || "",
        name: addressTax?.name || "",
        address: addressTax?.address_text || "",
        telephone: addressTax?.telephone || "",
        // fax: addressTax?.fax || null,
        // email: addressTax?.email || null,
      };
    }

    const factory_id = dataTemporary.find(
      (item) => item.factory_id
    )?.factory_id;
    let dataCreate: FactoryCreateOrderInput;
    if (values.bank_id) {
      dataCreate = {
        factory_id: factory_id || "",
        // [refIdKey]: id || '',
        agent_id: id || "",
        ship_address: shipAddressData,
        payment_type: "manual_transfer",
        datasource: values.datasource,
        ref_type: refType,
        transport_price: servicePrice,
        product_list: productItems,
        payment: [payment],
        due_date: dueDate ? dayjs(dueDate).format("YYYY-MM-DD") : null,
        memo: values.memo,
        discount_amount: disCount,
        req_tax: requestTax,
        ...(taxInvoiceItems && requestTax
          ? { tax_invoice: taxInvoiceItems }
          : {}),
        is_vip: false,
      };
    } else {
      dataCreate = {
        factory_id: factory_id || "",
        agent_id: id || "",
        ship_address: shipAddressData,
        payment_type: "manual_transfer",
        datasource: values.datasource,
        ref_type: refType,
        transport_price: servicePrice,
        product_list: productItems,
        due_date: dueDate ? dayjs(dueDate).format("YYYY-MM-DD") : null,
        memo: values.memo,
        discount_amount: disCount,
        req_tax: requestTax,
        ...(taxInvoiceItems && requestTax
          ? { tax_invoice: taxInvoiceItems }
          : {}),
        is_vip: false,
      };
    }
    // setOrderData(dataCreate);
    createOrderAdmin(dataCreate, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("สร้างคำสั่งซื้อสำเร็จ");
          formSubmit.resetFields();
          setDueDate(null);
          setDataTemporary([]);
          refectNewOrders();
          onClose();
        } else {
          message.error(`สร้างคำสั่งซื้อไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`สร้างคำสั่งซื้อไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  const changeDefault = (id: string) => {
    setRadioSelect(id); // const targetAddress = dataAddress.find((address) => address.address_id === id || address.temp_id === id);
    // console.log(createOrderAddress.find((address) => address.address_id === radioSelect))
    // console.log(radioSelect)
    // if (targetAddress) {
    //   const updatedData = dataAddress.map((address) => ({
    //     ...address,
    //     is_default: address.address_id === id || address.temp_id === id,
    //   }));

    //   setDataAddress(updatedData);
    // }
  };

  const isDisabled = dataTemporary.length === 0 || radioSelect === "";
  return (
    <>
      {/* <FloatButtonStyled
        icon={<FileTextOutlined />}
        description="สร้างคำสั่งซื้อ"
        shape="square"
        type="primary"
        style={{ top:180,right: 0 }}
        onClick={()=> {
          showDrawer();
        }}    
      />   */}
      <FormWrapper>
        {/* <ButtonWrapper>
          <StyledButton type="primary" onClick={() => {
            showDrawer();
          } }><PlusOutlined /> สร้างคำสั่งซื้อ</StyledButton>
        </ButtonWrapper> */}
        <Row className="rowgap-vbox">
          <Col sm={24} md={24}>
            <Tabs
              defaultActiveKey={tabsKey ? tabsKey : "0"}
              style={{ height: "100%" }}
              items={items}
              key="key"
              // onChange={(key) => {
              //   dispatch(setTabSelected(key));
              // }}
            />
          </Col>
        </Row>
      </FormWrapper>
      {/* modal */}
      <Modal
        title="เพิ่มคำสั่งซื้อใหม่"
        open={openForm}
        width={1000}
        maskClosable={false}
        onCancel={onClose}
        style={{ top: 20 }}
        // onOk={() => {
        //   formSubmit.submit();
        // }}
        // cancelText="ยกเลิก" okText="บันทึกคำสั่งซื้อใหม่"
        footer={[
          <Button
            // disabled={isDisabled}
            key="back"
            onClick={() => {
              onClose();
            }}>
            ยกเลิก
          </Button>,
          <Button
            disabled={isDisabled}
            key="submit"
            type="primary"
            onClick={() => formSubmit.submit()}>
            บันทึกคำสั่งซื้อใหม่
          </Button>,
        ]}>
        <WrapperAll>
          <Form form={formSubmit} onFinish={onFinishAdd}>
            <AgentAddressCardList
              dataAddress={createOrderAddress}
              form={formAdd}
              changeDefault={changeDefault}
              canUpdate={canUpdate}
              radioSelect={radioSelect}
              canSort={canSort}
            />
            <Divider />
            <MainCreateOrderTax
              refetchData={refetchTax}
              dataAddressTax={dataAddressTax}
              setDataAddressTax={setDataAddressTax}
              refId={id}
              refType={"agent"}
              requestTax={requestTax}
              setRequestTax={setRequestTax}
              addressIdSelected={addressIdSelected}
              setAddressIdSelected={setAddressIdSelected}
            />
            <Divider />
            <MainOrderDatasource form={formSubmit} />
            <Divider />
            <MainCreateOrderDuedate dueDate={dueDate} setDueDate={setDueDate} />
            <Divider />
            <MainCreateOrderProduct
              refId={id}
              refType={refType}
              dataTemporary={dataTemporary}
              setDataTemporary={setDataTemporary}
              canDelete={true}
              canCreate={true}
              showStatusColumn={false}
              setTotalPrice={setTotalPrice}
              editingKey={editingKey}
              setEditingKey={setEditingKey}
              currentSelected={currentSelected}
              setCurrentSelected={setCurrentSelected}
              userData={userData?.data}
            />
            <MainCreatePriceTransportation servicePrice={servicePrice} />
            <MainCreateTotalPricePayment
              servicePrice={servicePrice}
              totalPrice={totalPrice}
              disCount={disCount}
              setDisCount={setDisCount}
            />
            <Divider />
            <MainCreateOrderPayment
              childrenBank={childrenBank}
              paymentDate={paymentDate}
              setPaymentDate={setPaymentDate}
              switchOn={isSwitch}
            />
          </Form>
        </WrapperAll>
      </Modal>
    </>
  );
};

export default MainCreateAgentOrder;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const FloatButtonStyled = styled(FloatButton)`
  width: 60px;
  height: 40px;
  margin-right: 5px;
`;
const OptionContent = styled.div`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled.div`
  margin-right: 8px;
  width: 20px;
  height: 20px;
  img {
    margin-top: -10px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
